import * as React from "react";
import { Avatar } from "@mantine/core";
import { apiAddress } from "../../config/server";
import { ImageSize } from "../../types/image/image";

export const getPersonAvatarCss = (
  size: ImageSize | "original" | "small" | "medium" | "large",
): React.CSSProperties => {
  let s: number | null = null;
  switch (size) {
    case ImageSize.small: {
      s = 48;
      break;
    }
    case ImageSize.medium: {
      s = 96;
      break;
    }
    case ImageSize.large: {
      s = 200;
      break;
    }
    case ImageSize.original: {
      s = null;
      break;
    }
    default: {
      console.log("Couldn't satisfy switch");
      break;
    }
  }
  if (!s) {
    return {
      borderRadius: "50%",
      margin: "4px",
    };
  }

  return {
    width: `${s}px`,
    height: `${s}px`,
    borderRadius: "50%",
    margin: "4px",
  };
};

interface PersonAvatarProps {
  size?: ImageSize | "original" | "small" | "medium" | "large";
  image: string | null;
  className?: string;
  style?: React.CSSProperties;
}

export const getPersonAvatarLink = (
  image: string | null,
  size: ImageSize | "original" | "small" | "medium" | "large",
) => `${apiAddress}/api/image/${image || "default"}/${size}`;

const PersonAvatar: React.FunctionComponent<PersonAvatarProps> = ({
  image,
  size,
  style,
  ...other
}) => {
  const s = size || "small";
  const src = getPersonAvatarLink(image, s);

  return (
    <Avatar
      {...other}
      src={src}
      style={{ ...getPersonAvatarCss(s), ...style }}
      className={`${other.className || ""} avatar`}
    />
  );
};

export default PersonAvatar;
